import React, { useState, useEffect, useRef } from 'react';
import { Printer, Send, Edit, X, Upload } from 'lucide-react';
import apiService from "../../config";
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const Namuna_A = ({ setSubComponent }) => {
  const documentRef = useRef(null);

  // Project and Proposal IDs
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);

  // Data states
  const [rehabData, setRehabData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Edit states
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingRehab, setEditingRehab] = useState(null);
  const [editForm, setEditForm] = useState({
    plot_no: '',
    plot_size: '',
    area_sq_mtr: '',
    remarks: '',
    boundary_north: '',
    boundary_south: '',
    boundary_east: '',
    boundary_west: ''
  });

  // Send to DRO states
  const [showSendToDROModal, setShowSendToDROModal] = useState(false);
  const [remarksDRO, setRemarksDRO] = useState('Approved');
  const [selectedUserDRO, setSelectedUserDRO] = useState('');
  const [sendingToDRO, setSendingToDRO] = useState(false);
  const [selectedDocumentDRO, setSelectedDocumentDRO] = useState(null);
  const [usersDRO, setUsersDRO] = useState([]);
  const [loadingUsersDRO, setLoadingUsersDRO] = useState(false);

  // User role
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
  const PROJECT_INCHARGE_ROLE = 18;

  // Add Rehab Modal
  const [showAddModal, setShowAddModal] = useState(false);

  const [droButtonDisabled, setDroButtonDisabled] = useState(false);
  const [checkingDroButton, setCheckingDroButton] = useState(false);
  const [fullName, setFullName] = useState('');
  const [designation, setDesignation] = useState('');

  // Location dropdown states
  const [districts, setDistricts] = useState([]);

  // नव पुनर्वासित
  const [rehabDistrict, setRehabDistrict] = useState('');
  const [rehabTaluka, setRehabTaluka] = useState('');
  const [rehabVillage, setRehabVillage] = useState('');
  const [rehabTalukas, setRehabTalukas] = useState([]);
  const [rehabVillages, setRehabVillages] = useState([]);

  // मौजे पलशीफाटा
  const [baseDistrict, setBaseDistrict] = useState('');
  const [baseTaluka, setBaseTaluka] = useState('');
  const [baseVillage, setBaseVillage] = useState('');
  const [baseTalukas, setBaseTalukas] = useState([]);
  const [baseVillages, setBaseVillages] = useState([]);

  // Nav Punrvasit (New Rehab Village)
  const [rehabNewDistrict, setRehabNewDistrict] = useState("");
  const [rehabNewTaluka, setRehabNewTaluka] = useState("");
  const [rehabNewVillage, setRehabNewVillage] = useState("");

  const [rehabNewTalukas, setRehabNewTalukas] = useState([]);
  const [rehabNewVillages, setRehabNewVillages] = useState([]);

  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const {
    uploadStatus,
    uploadError,
    selectedSignDocument,
    resetSignatureState,
    setUploadStatus,
    setUploadError,
    signDocument
  } = useSignature();

  const getDistrictName = (id) =>
    districts.find(d => d.dist_no == id)?.dist_name;

  const getTalukaName = (list, id) =>
    list.find(t => t.taluka_no == id)?.taluka_name;

  const getVillageName = (list, id) =>
    list.find(v => v.village_id == id)?.village_name;

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    setFullName(userData.full_name || '');
    setDesignation(userData.designation || '');
  }, []);

  useEffect(() => {
    if (showAddModal) {
      fetchDistricts();
    }
  }, [showAddModal]);

  const fetchDistricts = async () => {
    try {
      const res = await apiService.getDistricts();
      const districtList = res?.data?.data || res?.data || [];
      setDistricts(Array.isArray(districtList) ? districtList : []);
    } catch (err) {
      console.error(err);
      setDistricts([]);
    }
  };

  const handleRehabDistrictChange = async (e) => {
    const districtName = e.target.value;
    setRehabDistrict(districtName);
    setRehabTaluka('');
    setRehabVillage('');
    setRehabTalukas([]);
    setRehabVillages([]);

    if (!districtName) return;

    console.log('Fetching Rehab Talukas for district:', districtName);

    try {
      const res = await apiService.getTalukas(districtName);
      console.log('Rehab Talukas API Response:', res);

      const talukaList = res?.data?.data || res?.data || [];
      console.log('Rehab Talukas extracted:', talukaList);

      setRehabTalukas(Array.isArray(talukaList) ? talukaList : []);
    } catch (err) {
      console.error("Taluka fetch failed", err);
      setRehabTalukas([]);
    }
  };

  const handleRehabTalukaChange = async (e) => {
    const talukaName = e.target.value;
    setRehabTaluka(talukaName);
    setRehabVillage('');
    setRehabVillages([]);

    if (!rehabDistrict || !talukaName) return;

    console.log('Fetching Rehab Villages for:', rehabDistrict, talukaName);

    try {
      const res = await apiService.getVillages(rehabDistrict, talukaName);
      console.log('Rehab Villages API Response:', res);

      const villageList = res?.data?.data || res?.data || [];
      console.log('Rehab Villages extracted:', villageList);

      setRehabVillages(Array.isArray(villageList) ? villageList : []);
    } catch (err) {
      console.error("Village fetch failed", err);
      setRehabVillages([]);
    }
  };

  const handleBaseDistrictChange = async (e) => {
    const districtName = e.target.value;
    setBaseDistrict(districtName);
    setBaseTaluka('');
    setBaseVillage('');
    setBaseTalukas([]);
    setBaseVillages([]);

    if (!districtName) return;

    try {
      const res = await apiService.getTalukas(districtName);
      const talukaList = res?.data?.data || res?.data || [];
      setBaseTalukas(Array.isArray(talukaList) ? talukaList : []);
    } catch (err) {
      console.error('Error fetching base talukas:', err);
      setBaseTalukas([]);
    }
  };

  const handleBaseTalukaChange = async (e) => {
    const talukaName = e.target.value;
    setBaseTaluka(talukaName);
    setBaseVillage('');
    setBaseVillages([]);

    if (!baseDistrict || !talukaName) return;

    try {
      const res = await apiService.getVillages(baseDistrict, talukaName);
      const villageList = res?.data?.data || res?.data || [];
      setBaseVillages(Array.isArray(villageList) ? villageList : []);
    } catch (err) {
      console.error('Error fetching base villages:', err);
      setBaseVillages([]);
    }
  };

  const [addForm, setAddForm] = useState({
    plot_no: '',
    plot_size: '',
    area_sq_mtr: '',
    remarks: '',
    boundary_north: '',
    boundary_south: '',
    boundary_east: '',
    boundary_west: '',
    document: null
  });

  const fetchDROButtonStatus = async () => {
    try {
      if (!currentProjectId || !currentProposalId) return;

      setCheckingDroButton(true);

      const response = await apiService.getDROButton(
        currentProjectId,
        currentProposalId,
        'NamunaADRO'
      );
      setDroButtonDisabled(!response.buttonDisable);

    } catch (error) {
      console.error('Error fetching DRO button status:', error);
      setDroButtonDisabled(true);
    } finally {
      setCheckingDroButton(false);
    }
  };


  useEffect(() => {
    fetchDROButtonStatus();
  }, [currentProjectId, currentProposalId, userRole]);


  const handleAddChange = (e) => {
    const { name, value, files } = e.target;
    setAddForm(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  const handleUploadedFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    resetSignatureState();     // 🔥 important
    setPdfForSigning(file);
    setShowSignaturePad(true);
  };

  useEffect(() => {
    if (!selectedSignDocument) return;

    const postSignedPdf = async () => {
      try {
        const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
        const projectId = selectedProject?.id || selectedProject?.project_id;
        const proposalId = localStorage.getItem("currentProposalId");

        if (!projectId || !proposalId) {
          console.error("Missing projectId or proposalId");
          return;
        }

        await apiService.postAddSignaturePDF(
          projectId,
          proposalId,
          "Praruplist",      // 🔁 change per section
          selectedSignDocument   // ✅ signed PDF only
        );

        const sectionRes = await apiService.getSectionFile(
          projectId,
          proposalId,
          "Praruplist"
        );

        if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
          setPreviewUrl(sectionRes.data[0].file_path);
        }

      } catch (error) {
        console.error("Error posting signed PDF:", error);
      }
    };

    postSignedPdf();
  }, [selectedSignDocument]);

  const handleViewSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        alert("Project or Proposal not found");
        return;
      }

      const res = await apiService.getSectionFile(
        projectId,
        proposalId,
        "Praruplist" // 🔁 change per section
      );

      if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
        setViewerFile(res.data[0].file_path);
        setIsViewerOpen(true);     // modal
        // OR 👉 window.open(res.data[0].file_path, "_blank");
      } else {
        alert("Signed document not available");
      }
    } catch (error) {
      console.error("Error viewing signed PDF:", error);
      alert("Unable to open signed document");
    }
  };

  const SignatureLoader = ({ text }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
        <p className="text-sm font-medium text-gray-700">{text}</p>
      </div>
    </div>
  );

  const handleSubmit = async () => {
    // Validation
    if (!rehabDistrict || !rehabTaluka || !rehabVillage) {
      alert('कृपया नव पुनर्वासित गाव माहिती पूर्ण करा');
      return;
    }
    if (!baseDistrict || !baseTaluka || !baseVillage) {
      alert('कृपया मौजे पलशीफाटा माहिती पूर्ण करा');
      return;
    }
    if (!addForm.plot_no || !addForm.area_sq_mtr) {
      alert('कृपया भूखंड क्रमांक आणि क्षेत्रफळ भरा');
      return;
    }

    const formData = new FormData();
    formData.append('project_id', currentProjectId);
    formData.append('proposal_id', currentProposalId);
    formData.append('district_name', rehabDistrict);
    formData.append('taluka_name', rehabTaluka);
    formData.append('village_name', rehabVillage);
    formData.append('base_district_name', baseDistrict);
    formData.append('base_taluka_name', baseTaluka);
    formData.append('base_village_name', baseVillage);
    formData.append('plot_no', addForm.plot_no);
    formData.append('plot_size', addForm.plot_size);
    formData.append('area_sq_mtr', addForm.area_sq_mtr);
    formData.append('boundary_north', addForm.boundary_north);
    formData.append('boundary_south', addForm.boundary_south);
    formData.append('boundary_east', addForm.boundary_east);
    formData.append('boundary_west', addForm.boundary_west);
    formData.append('remarks', addForm.remarks);
    if (addForm.document) {
      formData.append('document', addForm.document);
    }

    try {
      setLoading(true);
      await apiService.postAddRehabA(formData);
      alert('यशस्वीरित्या जोडले / Successfully added!');
      setShowAddModal(false);
      resetAddForm();
      fetchRehabData();
    } catch (err) {
      console.error('Error adding record:', err);
      alert('जोडण्यात अयशस्वी / Failed to add');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showAddModal && rehabData.length > 0) {
      // Get the last record from rehabData
      const lastRecord = rehabData[rehabData.length - 1];

      // Pre-select नव पुनर्वासित गाव (Rehab Village)
      if (lastRecord.district_name) {
        setRehabDistrict(lastRecord.district_name);

        // Fetch talukas for the district
        apiService.getTalukas(lastRecord.district_name).then(res => {
          const talukaList = res?.data?.data || res?.data || [];
          setRehabTalukas(Array.isArray(talukaList) ? talukaList : []);

          // Pre-select taluka
          if (lastRecord.taluka_name) {
            setRehabTaluka(lastRecord.taluka_name);

            // Fetch villages for the taluka
            apiService.getVillages(lastRecord.district_name, lastRecord.taluka_name).then(res => {
              const villageList = res?.data?.data || res?.data || [];
              setRehabVillages(Array.isArray(villageList) ? villageList : []);

              // Pre-select village
              if (lastRecord.village_name) {
                setRehabVillage(lastRecord.village_name);
              }
            }).catch(err => console.error("Error fetching villages:", err));
          }
        }).catch(err => console.error("Error fetching talukas:", err));
      }

      // Pre-select मौजे पलशीफाटा (Base Village)
      if (lastRecord.base_district_name) {
        setBaseDistrict(lastRecord.base_district_name);

        // Fetch talukas for the base district
        apiService.getTalukas(lastRecord.base_district_name).then(res => {
          const talukaList = res?.data?.data || res?.data || [];
          setBaseTalukas(Array.isArray(talukaList) ? talukaList : []);

          // Pre-select base taluka
          if (lastRecord.base_taluka_name) {
            setBaseTaluka(lastRecord.base_taluka_name);

            // Fetch villages for the base taluka
            apiService.getVillages(lastRecord.base_district_name, lastRecord.base_taluka_name).then(res => {
              const villageList = res?.data?.data || res?.data || [];
              setBaseVillages(Array.isArray(villageList) ? villageList : []);

              // Pre-select base village
              if (lastRecord.base_village_name) {
                setBaseVillage(lastRecord.base_village_name);
              }
            }).catch(err => console.error("Error fetching base villages:", err));
          }
        }).catch(err => console.error("Error fetching base talukas:", err));
      }
    }
  }, [showAddModal, rehabData]);

  const resetAddForm = () => {
    setAddForm({
      plot_no: '',
      plot_size: '',
      area_sq_mtr: '',
      remarks: '',
      boundary_north: '',
      boundary_south: '',
      boundary_east: '',
      boundary_west: '',
      document: null
    });

    // Only reset dropdowns if there's no data to pre-populate
    if (rehabData.length === 0) {
      setRehabDistrict('');
      setRehabTaluka('');
      setRehabVillage('');
      setRehabTalukas([]);
      setRehabVillages([]);
      setBaseDistrict('');
      setBaseTaluka('');
      setBaseVillage('');
      setBaseTalukas([]);
      setBaseVillages([]);
    }
  };

  // Get Project and Proposal IDs
  useEffect(() => {
    const getProjectInfo = () => {
      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return project.project_id || project.id;
        } catch (e) {
          console.error('Error parsing selectedProject:', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          return user.data?.project_id || user.project_id;
        } catch (e) {
          console.error('Error parsing userData:', e);
        }
      }
      return null;
    };

    const getProposalInfo = () => {
      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          return user?.data?.default_proposal || user?.data?.proposal_id || user?.default_proposal || user?.proposal_id || null;
        } catch (e) {
          console.error('Error parsing userData for proposal:', e);
        }
      }
      return null;
    };

    setCurrentProjectId(getProjectInfo());
    setCurrentProposalId(getProposalInfo());
  }, []);

  useEffect(() => {
    if (currentProjectId && currentProposalId) {
      fetchRehabData();
    }
  }, [currentProjectId, currentProposalId]);

  const fetchRehabData = async () => {
    try {
      setLoading(true);
      const files = await apiService.getRehabA(currentProjectId, currentProposalId);
      setRehabData(files);
    } catch (error) {
      console.error("Rehab API failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsersDRO = async () => {
    const role = 22;
    setLoadingUsersDRO(true);
    try {
      const response = await apiService.getAllUserRoleDRO(role, currentProjectId, currentProposalId);
      if (response.status === 200 && response.data) {
        setUsersDRO(Array.isArray(response.data) ? response.data : []);
      } else {
        setUsersDRO([]);
      }
    } catch (error) {
      console.error('Error fetching DRO users:', error);
      setUsersDRO([]);
    } finally {
      setLoadingUsersDRO(false);
    }
  };

  useEffect(() => {
    if (showSendToDROModal) {
      fetchUsersDRO();
    }
  }, [showSendToDROModal]);

  const handleEdit = (item) => {
    setEditingRehab(item);
    setEditForm({
      plot_no: item.plot_no || '',
      plot_size: item.plot_size || item.area || '',
      area_sq_mtr: item.area_sq_mtr || '',
      remarks: item.remarks || '',
      boundary_north: item.boundary_north || '',
      boundary_south: item.boundary_south || '',
      boundary_east: item.boundary_east || '',
      boundary_west: item.boundary_west || ''
    });
    setShowEditModal(true);
  };
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpdateRemarks = async () => {
    if (!editingRehab) return;

    try {
      setLoading(true);
      const payload = new FormData();
      payload.append('plot_no', editForm.plot_no);
      payload.append('plot_size', editForm.plot_size);
      payload.append('area_sq_mtr', editForm.area_sq_mtr);
      payload.append('boundary_north', editForm.boundary_north);
      payload.append('boundary_south', editForm.boundary_south);
      payload.append('boundary_east', editForm.boundary_east);
      payload.append('boundary_west', editForm.boundary_west);
      payload.append('remarks', editForm.remarks);

      const rehabId = editingRehab.rehab_id || editingRehab.id;
      const response = await apiService.patchUpdateRehabA(rehabId, payload);

      if (response.status === 200) {
        alert('यशस्वीरित्या अद्यतनित केले / Updated successfully!');
        setShowEditModal(false);
        setEditingRehab(null);
        setEditForm({
          plot_no: '',
          plot_size: '',
          area_sq_mtr: '',
          remarks: '',
          boundary_north: '',
          boundary_south: '',
          boundary_east: '',
          boundary_west: ''
        });
        fetchRehabData();
      }
    } catch (error) {
      console.error('Error updating:', error);
      alert('अद्यतनित करण्यात अयशस्वी / Failed to update');
    } finally {
      setLoading(false);
    }
  };

  const handleSendToDRO = async () => {
    if (!selectedUserDRO || !selectedDocumentDRO) {
      alert('Please select user and upload document');
      return;
    }

    setSendingToDRO(true);

    try {
      const formData = new FormData();
      formData.append('project_id', currentProjectId);
      formData.append('proposal_id', currentProposalId);
      formData.append('remarks', remarksDRO);
      formData.append('usr_id', selectedUserDRO);
      formData.append('document', selectedDocumentDRO);

      const response = await apiService.postTrackingSendToDRO(formData);

      if (response.status === 200) {
        alert('Successfully sent to DRO');
        setShowSendToDROModal(false);
        setSelectedUserDRO('');
        setRemarksDRO('Approved');
        setSelectedDocumentDRO(null);
        fetchDROButtonStatus();
      } else {
        alert('Failed to send to DRO');
      }
    } catch (error) {
      console.error('Error sending to DRO:', error);
      alert('Failed to send to DRO');
    } finally {
      setSendingToDRO(false);
    }
  };

  const handlePlotAllotmentLetter = () => {
    setSubComponent("PlotAllotmentLetter");
  };

  const handleluckydraw = () => {
    setSubComponent("Luckydraw")
  }


  // -------------------------------------------
  const handleRehabNewDistrictChange = async (e) => {
    const districtId = e.target.value;

    setRehabNewDistrict(districtId);
    setRehabNewTaluka('');
    setRehabNewVillage('');
    setRehabNewTalukas([]);
    setRehabNewVillages([]);

    // Convert ID → NAME (same as Base)
    const districtName = getDistrictName(districtId);
    if (!districtName) return;

    console.log('Fetching RehabNew Talukas for district:', districtName);

    try {
      const res = await apiService.getTalukas(districtName);
      const talukaList = res?.data?.data || res?.data || [];
      console.log('RehabNew Talukas received:', talukaList);

      setRehabNewTalukas(Array.isArray(talukaList) ? talukaList : []);
    } catch (err) {
      console.error('Error fetching RehabNew talukas:', err);
      setRehabNewTalukas([]);
    }
  };


  const handleRehabNewTalukaChange = async (e) => {
    const talukaId = e.target.value;

    setRehabNewTaluka(talukaId);
    setRehabNewVillage('');
    setRehabNewVillages([]);

    // Convert IDs → NAMES (same as Base)
    const districtName = getDistrictName(rehabNewDistrict);
    const talukaName = getTalukaName(rehabNewTalukas, talukaId);

    if (!districtName || !talukaName) return;

    console.log('Fetching RehabNew Villages for:', districtName, talukaName);

    try {
      const res = await apiService.getVillages(districtName, talukaName);
      const villageList = res?.data?.data || res?.data || [];
      console.log('RehabNew Villages received:', villageList);

      setRehabNewVillages(Array.isArray(villageList) ? villageList : []);
    } catch (err) {
      console.error('Error fetching RehabNew villages:', err);
      setRehabNewVillages([]);
    }
  };
  const handleRehabNewVillageChange = (e) => {
    const villageId = e.target.value;
    setRehabNewVillage(villageId);
  };

  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) {
      alert("No content available to print.");
      return;
    }

    const printWindow = window.open('about:blank', '_blank');

    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Print - नमुना "अ" रजिस्टर</title>
        <meta charset="UTF-8">
        <style>
          @media print {
            .page-break {
              page-break-before: always;
            }
            .no-print {
              display: none !important;
            }
          }
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body { 
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          
          table { 
            border-collapse: collapse; 
            width: 100%; 
            border: 2px solid black;
            margin-top: 20px;
          }
          
          th, td { 
            border: 2px solid black; 
            padding: 8px;
            font-size: 14px;
          }
          
          th { 
            background-color: #f3f4f6;
            font-weight: bold;
          }

          .signature{
            text-align : right;
            margin-top : 40px;
            }
          
          .text-center { 
            text-align: center; 
          }
          
          .bg-gray-100 { 
            background-color: #f3f4f6; 
          }
          
          .bg-gray-50 { 
            background-color: #f9fafb; 
          }
          
          h1 {
            font-size: 18px;
            font-weight: bold;
            margin: 10px 0;
          }
          
          h2 {
            font-size: 16px;
            font-weight: 600;
            margin: 8px 0;
          }
          
          h3 {
            font-size: 18px;
            font-weight: 600;
            margin: 10px 0;
          }
          
          .space-y-2 > * + * {
            margin-top: 8px;
          }
          
          .mb-6 {
            margin-bottom: 24px;
          }
          
          .mt-12 {
            margin-top: 48px;
          }
          
          @media print {
            body {
              padding: 10px;
            }
          }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);

    printWindow.document.close();

    // Wait for content to load before printing
    printWindow.onload = function () {
      printWindow.focus();
      printWindow.print();
    };
  };

  const headerData = rehabData?.[0] || {};

  // Add this function before the return statement
  const groupRehabData = () => {
    const grouped = {};

    rehabData.forEach(item => {
      const key = `${item.district_name}|${item.taluka_name}|${item.village_name}|${item.base_district_name}|${item.base_taluka_name}|${item.base_village_name}`;

      if (!grouped[key]) {
        grouped[key] = {
          district_name: item.district_name,
          taluka_name: item.taluka_name,
          village_name: item.village_name,
          base_district_name: item.base_district_name,
          base_taluka_name: item.base_taluka_name,
          base_village_name: item.base_village_name,
          items: []
        };
      }

      grouped[key].items.push(item);
    });

    return Object.values(grouped);
  };

  return (
    <div className="max-w-5xl mx-auto p-6">

      <div className="flex justify-between items-center mb-4">

        <div className="flex gap-2">

          {userRole === PROJECT_INCHARGE_ROLE && (
            <button
              onClick={() => setShowAddModal(true)}
              className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors shadow-md"
            >
              + नोंद जोडा
            </button>
          )}

          {/* <button className="relative">
          <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
            <Upload size={18} />
            <span>Upload Signature</span>
            <input
              type="file"
              accept="application/pdf,image/*"
              className="hidden"
              onChange={handleUploadedFile}
            />
          </label>
        </button>

        <button
          onClick={handleViewSignedPdf}
          className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
        >
          <Printer size={18} />
          <span>View Signed PDF</span>
        </button> */}

          <button
            onClick={handleluckydraw}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-md"
          >
            draw
          </button>

          <button
            onClick={handlePlotAllotmentLetter}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-md"
          >
            भूखंडवाटपाची चिठ्ठी
          </button>

          <button
            onClick={handlePrint}
            className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-md"
          >
            <Printer size={20} />
            Print
          </button>
        </div>

         
          {userRole === PROJECT_INCHARGE_ROLE && (
             <div className="flex flex-wrap items-center gap-3 p-3 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
            <button
              onClick={() => setShowSendToDROModal(true)}
              // disabled={checkingDroButton || droButtonDisabled}
              className={`px-4 py-2 rounded-lg transition-colors shadow-md ${droButtonDisabled
                ? 'bg-red-600 text-white hover:bg-red-700'
                : checkingDroButton
                  ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                  : 'bg-purple-600 text-white hover:bg-purple-700'
                }`}
            >
              <Send className="inline mr-2" size={16} />
              Send to DRO
            </button>
            </div>
          )}
        

      </div>

      {/* Loading State */}
      {loading && (
        <div className="text-center py-10">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading data...</p>
        </div>
      )}

      {/* Document Preview */}
      {!loading && (
        <div ref={documentRef} className="bg-white rounded-lg shadow-lg p-8">
          {groupRehabData().map((group, groupIndex) => (
            <div key={groupIndex} className={groupIndex > 0 ? "mt-12 page-break" : ""}>
              <div className="text-center space-y-2 mb-6">
                <h1 className="text-lg font-bold">
                  मौजे {group.village_name} टा. तालुका {group.taluka_name} जिल्हा {group.district_name} येथील नवीन पुनर्वसित गावठाण
                </h1>
                <h2 className="text-base font-semibold">
                  मौजे {group.base_village_name} तालुका {group.base_taluka_name} जिल्हा {group.base_district_name} च्या अभिन्यासाप्रमाणे
                </h2>
                <h3 className="text-lg font-semibold">नमुना "अ" रजिस्टर</h3>
              </div>

              <table className="w-full border-collapse border-2 border-black">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border-2 border-black p-2 text-center">अ.क्र.</th>
                    <th className="border-2 border-black p-2 text-center">भूखंड क्रमांक</th>
                    <th className="border-2 border-black p-2 text-center">भूखंडाचा आकार</th>
                    <th className="border-2 border-black p-2 text-center">क्षेत्रफळ चौ.मी.</th>
                    <th className="border-2 border-black p-2 text-center">चत:सीमा</th>
                    <th className="border-2 border-black p-2 text-center">शेरा</th>
                  </tr>
                  <tr className="bg-gray-50">
                    <th className="border-2 border-black p-2 text-center">१</th>
                    <th className="border-2 border-black p-2 text-center">२</th>
                    <th className="border-2 border-black p-2 text-center">३</th>
                    <th className="border-2 border-black p-2 text-center">४</th>
                    <th className="border-2 border-black p-2 text-center">५</th>
                    <th className="border-2 border-black p-2 text-center">६</th>
                  </tr>
                </thead>
                <tbody>
                  {group.items.map((row, index) => {
                    const boundaries = [
                      row.boundary_north ? `उत्तर :- ${row.boundary_north}` : null,
                      row.boundary_south ? `दक्षिण :- ${row.boundary_south}` : null,
                      row.boundary_east ? `पूर्व :- ${row.boundary_east}` : null,
                      row.boundary_west ? `पश्चिम :- ${row.boundary_west}` : null
                    ].filter(Boolean);

                    return (
                      <React.Fragment key={row.rehab_id || row.id || index}>
                        {boundaries.map((boundary, idx) => (
                          <tr key={`${row.rehab_id || row.id}-${idx}`}>
                            {idx === 0 && (
                              <>
                                <td className="border-2 border-black p-2 text-center" rowSpan={boundaries.length}>
                                  {userRole === PROJECT_INCHARGE_ROLE && (
                                    <Edit
                                      size={16}
                                      onClick={() => handleEdit(row)}
                                      className="text-blue-600 hover:text-blue-800 no-print cursor-pointer inline-block"
                                      title="Edit"
                                    />
                                  )}
                                  <span className="ml-2">{index + 1}</span>
                                </td>
                                <td className="border-2 border-black p-2 text-center" rowSpan={boundaries.length}>
                                  {row.plot_no}
                                </td>
                                <td className="border-2 border-black p-2 text-center" rowSpan={boundaries.length}>
                                  {row.area || row.plot_size || '-'}
                                </td>
                                <td className="border-2 border-black p-2 text-center" rowSpan={boundaries.length}>
                                  {row.area_sq_mtr || row.plot_size}
                                </td>
                              </>
                            )}
                            <td className="border-2 border-black p-2">{boundary}</td>
                            {idx === 0 && (
                              <td className="border-2 border-black p-2" rowSpan={boundaries.length}>
                                {row.remarks || ''}
                              </td>
                            )}
                          </tr>
                        ))}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
              {/* <div className="mt-10 text-right signature">
                <div className="font-bold">{fullName}</div>
                <div>{designation}</div>
              </div> */}
            </div>
          ))}
        </div>
      )}

      {showEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl my-8">
            <div className="p-6 max-h-[85vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gray-800">माहिती संपादित करा</h2>
                <button
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingRehab(null);
                    setEditForm({
                      plot_no: '',
                      plot_size: '',
                      area_sq_mtr: '',
                      remarks: '',
                      boundary_north: '',
                      boundary_south: '',
                      boundary_east: '',
                      boundary_west: ''
                    });
                  }}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X size={24} />
                </button>
              </div>

              {/* भूखंड माहिती */}
              <div className="mb-6 p-4 bg-orange-50 rounded-lg border border-orange-200">
                <h3 className="text-lg font-semibold mb-3 text-orange-900">भूखंड माहिती</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">भूखंड क्रमांक *</label>
                    <input
                      name="plot_no"
                      value={editForm.plot_no}
                      onChange={handleEditChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                      placeholder="भूखंड क्रमांक"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">भूखंडाचा आकार</label>
                    <input
                      name="plot_size"
                      value={editForm.plot_size}
                      onChange={handleEditChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                      placeholder="भूखंडाचा आकार"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">क्षेत्रफळ (चौ.मी.) *</label>
                    <input
                      name="area_sq_mtr"
                      value={editForm.area_sq_mtr}
                      onChange={handleEditChange}
                      type="number"
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                      placeholder="क्षेत्रफळ"
                    />
                  </div>
                </div>
              </div>

              {/* चत:सीमा */}
              <div className="mb-6 p-4 bg-purple-50 rounded-lg border border-purple-200">
                <h3 className="text-lg font-semibold mb-3 text-purple-900">चत:सीमा</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">उत्तर सीमा</label>
                    <input
                      name="boundary_north"
                      value={editForm.boundary_north}
                      onChange={handleEditChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
                      placeholder="उत्तर सीमा"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">दक्षिण सीमा</label>
                    <input
                      name="boundary_south"
                      value={editForm.boundary_south}
                      onChange={handleEditChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
                      placeholder="दक्षिण सीमा"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">पूर्व सीमा</label>
                    <input
                      name="boundary_east"
                      value={editForm.boundary_east}
                      onChange={handleEditChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
                      placeholder="पूर्व सीमा"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">पश्चिम सीमा</label>
                    <input
                      name="boundary_west"
                      value={editForm.boundary_west}
                      onChange={handleEditChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
                      placeholder="पश्चिम सीमा"
                    />
                  </div>
                </div>
              </div>

              {/* शेरा */}
              <div className="mb-6">
                <label className="block text-sm font-medium mb-2">शेरा (Remarks)</label>
                <textarea
                  name="remarks"
                  value={editForm.remarks}
                  onChange={handleEditChange}
                  rows={4}
                  className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="शेरा प्रविष्ट करा"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  onClick={() => {
                    setShowEditModal(false);
                    setEditingRehab(null);
                    setEditForm({
                      plot_no: '',
                      plot_size: '',
                      area_sq_mtr: '',
                      remarks: '',
                      boundary_north: '',
                      boundary_south: '',
                      boundary_east: '',
                      boundary_west: ''
                    });
                  }}
                  className="px-6 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  रद्द करा
                </button>
                <button
                  onClick={handleUpdateRemarks}
                  disabled={loading}
                  className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors flex items-center"
                >
                  {loading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      जतन करत आहे...
                    </>
                  ) : (
                    'जतन करा'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Add Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl my-8">
            <div className="p-6 max-h-[85vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">पुनर्वसन नोंद जोडा</h2>
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    resetAddForm();
                  }}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X size={24} />
                </button>
              </div>

              {/* नव पुनर्वासित गाव */}
              <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <h3 className="text-lg font-semibold mb-3 text-blue-900">नव पुनर्वासित गाव</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">जिल्हा *</label>
                    <select
                      value={rehabDistrict}
                      onChange={handleRehabDistrictChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    >
                      <option value="">जिल्हा निवडा</option>
                      {districts.map(d => (
                        <option key={d.dist_no} value={d.dist_name}>{d.dist_name}</option>
                      ))}
                    </select>

                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">तालुका *</label>
                    <select
                      value={rehabTaluka}
                      onChange={handleRehabTalukaChange}
                      disabled={!rehabDistrict}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                    >
                      <option value="">तालुका निवडा</option>
                      {rehabTalukas.map(t => (
                        <option key={t.taluka_no} value={t.taluka_name}>{t.taluka_name}</option>
                      ))}
                    </select>

                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">गाव *</label>
                    <select
                      value={rehabVillage}
                      onChange={(e) => setRehabVillage(e.target.value)}
                      disabled={!rehabTaluka}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                    >
                      <option value="">गाव निवडा</option>
                      {rehabVillages.map(v => (
                        <option key={v.village_id} value={v.village_name}>{v.village_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* मौजे पलशीफाटा */}
              <div className="mb-6 p-4 bg-green-50 rounded-lg border border-green-200">
                <h3 className="text-lg font-semibold mb-3 text-green-900">मौजे पलशीफाटा (मूळ गाव)</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">जिल्हा *</label>
                    <select
                      value={baseDistrict}
                      onChange={handleBaseDistrictChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    >
                      <option value="">जिल्हा निवडा</option>
                      {districts.map(d => (
                        <option key={d.dist_no} value={d.dist_name}>{d.dist_name}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">तालुका *</label>
                    <select
                      value={baseTaluka}
                      onChange={handleBaseTalukaChange}
                      disabled={!baseDistrict}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                    >
                      <option value="">तालुका निवडा</option>
                      {baseTalukas.map(t => (
                        <option key={t.taluka_no} value={t.taluka_name}>{t.taluka_name}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">गाव *</label>
                    <select
                      value={baseVillage}
                      onChange={e => setBaseVillage(e.target.value)}
                      disabled={!baseTaluka}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                    >
                      <option value="">गाव निवडा</option>
                      {baseVillages.map(v => (
                        <option key={v.village_id} value={v.village_name}>{v.village_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* भूखंड माहिती */}
              <div className="mb-6 p-4 bg-orange-50 rounded-lg border border-orange-200">
                <h3 className="text-lg font-semibold mb-3 text-orange-900">भूखंड माहिती</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">भूखंड क्रमांक *</label>
                    <input
                      name="plot_no"
                      placeholder="भूखंड क्रमांक प्रविष्ट करा"
                      value={addForm.plot_no}
                      onChange={handleAddChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">भूखंडाचा आकार</label>
                    <input
                      name="plot_size"
                      placeholder="भूखंडाचा आकार प्रविष्ट करा"
                      value={addForm.plot_size}
                      onChange={handleAddChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">क्षेत्रफळ (चौ.मी.) *</label>
                    <input
                      name="area_sq_mtr"
                      placeholder="क्षेत्रफळ प्रविष्ट करा"
                      value={addForm.area_sq_mtr}
                      onChange={handleAddChange}
                      type="number"
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    />
                  </div>
                </div>
              </div>

              {/* चत:सीमा */}
              <div className="mb-6 p-4 bg-purple-50 rounded-lg border border-purple-200">
                <h3 className="text-lg font-semibold mb-3 text-purple-900">चत:सीमा</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">उत्तर सीमा</label>
                    <input
                      name="boundary_north"
                      placeholder="उत्तर सीमा प्रविष्ट करा"
                      value={addForm.boundary_north}
                      onChange={handleAddChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">दक्षिण सीमा</label>
                    <input
                      name="boundary_south"
                      placeholder="दक्षिण सीमा प्रविष्ट करा"
                      value={addForm.boundary_south}
                      onChange={handleAddChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">पूर्व सीमा</label>
                    <input
                      name="boundary_east"
                      placeholder="पूर्व सीमा प्रविष्ट करा"
                      value={addForm.boundary_east}
                      onChange={handleAddChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">पश्चिम सीमा</label>
                    <input
                      name="boundary_west"
                      placeholder="पश्चिम सीमा प्रविष्ट करा"
                      value={addForm.boundary_west}
                      onChange={handleAddChange}
                      className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    />
                  </div>
                </div>
              </div>

              {/* शेरा आणि दस्तऐवज */}
              <div className="mb-6">
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-2">शेरा</label>
                  <textarea
                    name="remarks"
                    placeholder="शेरा प्रविष्ट करा"
                    value={addForm.remarks}
                    onChange={handleAddChange}
                    rows={3}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">दस्तऐवज</label>
                  <input
                    type="file"
                    name="document"
                    onChange={handleAddChange}
                    className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {addForm.document && (
                    <p className="text-sm text-green-600 mt-2">
                      निवडलेले: {addForm.document.name}
                    </p>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    resetAddForm();
                  }}
                  className="px-6 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  रद्द करा
                </button>
                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors flex items-center"
                >
                  {loading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      जतन करत आहे...
                    </>
                  ) : (
                    'जतन करा'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send to DRO Modal */}
      {showSendToDROModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <h2 className="text-xl font-bold mb-4">Send to DRO</h2>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Select DRO Officer *
                  </label>
                  <select
                    value={selectedUserDRO}
                    onChange={(e) => setSelectedUserDRO(e.target.value)}
                    disabled={loadingUsersDRO}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingUsersDRO ? 'Loading Users...' : 'Select User'}
                    </option>
                    {usersDRO.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Remarks
                  </label>
                  <textarea
                    value={remarksDRO}
                    onChange={(e) => setRemarksDRO(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocumentDRO(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocumentDRO && (
                    <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                      <p className="text-sm text-green-700 font-medium">
                        Selected: {selectedDocumentDRO.name}
                      </p>
                      <span className="text-xs text-green-600">
                        {(selectedDocumentDRO.size / 1024 / 1024).toFixed(2)} MB
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setShowSendToDROModal(false);
                    setSelectedDocumentDRO(null);
                  }}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToDRO}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSendToDRO}
                  disabled={sendingToDRO || !selectedUserDRO || !selectedDocumentDRO}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToDRO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Sending...
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      Send
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);

            // ✅ ONLY sign here
            signDocument(pdfForSigning, signaturesArray);

            setPdfForSigning(null);
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}

      {isViewerOpen && viewerFile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">

            <div className="flex justify-between items-center px-4 py-2 border-b">
              <h3 className="text-lg font-semibold">Signed Document</h3>
              <button
                onClick={() => setIsViewerOpen(false)}
                className="text-xl font-bold"
              >
                ✕
              </button>
            </div>

            <iframe
              src={viewerFile}
              title="Signed PDF Viewer"
              className="w-full h-full"
            />
          </div>
        </div>
      )}

      {(uploadStatus === "signing" || uploadStatus === "uploading") && (
        <SignatureLoader
          text={
            uploadStatus === "signing"
              ? "Applying digital signature…"
              : "Uploading signed document…"
          }
        />
      )}

    </div>
  );
};

export default Namuna_A;